import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpClient
} from '@angular/common/http';
import { catchError, Observable, of, take } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { Apis } from '../@shared/consts/api-address';

@Injectable({
  providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {

  constructor
    (
      private router: Router,
      private auth: AuthService,
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //remover propriedades vazias do objeto - problema com .NET 7
    this.replaceInputValues(req.body);

    const apiReq = this.auth.getAuthRequest(req, environment.api);
    return next.handle(apiReq).pipe(catchError((error, caught) => {
      console.log(error);
      //TODO: Quando o retorno da chamada principal (Backend porta 60157) retornar um 404, refaz a chamada no JSON SERVER (mock)
      if (!environment.production && error.status === 404) {
        console.log('Entrou no 404');
        const apiReq = this.auth.getAuthRequest(req, environment.debug);
        return next.handle(apiReq).pipe(
          catchError((err, caught) => {
            console.log(err);

            return of(err);
          }) as any);

      } else {
        this.handleInternetConnectivity(apiReq);
        this.handleAuthError(error);

        return of(error);
      }
    }) as any);
  }

  private replaceInputValues(object) {
    if (object) {
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          var value = object[key];
          if (typeof value === 'object') {
            this.replaceInputValues(value); // Chamada recursiva para objetos aninhados
          } else if (value === null || value === undefined || value === '') {
            delete object[key];
          }
          else if(value === "true" || value === "false"){
            object[key] = value === "true";
          }
        }
      }
    }
  }

  private handleInternetConnectivity(req: HttpRequest<any>) {
    var fullUri = environment.api + Apis.backEndHealthRoute
    if (req.url !== fullUri) {
      if (!window.navigator.onLine)
        this.showInternetError();
      this.sendHealthRequest();
    }
  }

  private sendHealthRequest() {
    this.httpClient
      .get(Apis.backEndHealthRoute, { responseType: 'text' })
      .pipe(take(1))
      .subscribe(
        (succeedResponse: any) => {
          if (succeedResponse.status != 200) {
            this.showInternetError();
          }
        },
        (errorResponse: any) => {
          if (errorResponse.status != 200) {
            this.showInternetError();
          }
        }
      );
  }

  private handleAuthError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 401) {
      console.warn('handled error ' + error.status);
      this.router.navigate(['login'])
        .then(() => {
          window.location.reload();
        });

      localStorage.clear();
      return of(error.message);
    } else if (error.status === 403) {
      this.router.navigate(['nopermission']);
    }
    throw error;
  }

  private showInternetError() {
    this.snackBar.open(
      'Não foi possível realizar a operação pois a rede parece estar inoperante no momento. Verifique sua conexão de rede.',
      'Ok',
      { duration: 5000, panelClass: 'danger-snackbar' }
    );
  }
}
